(function () {
    const modal = document.getElementById('videoModal');
    const closeBtn = document.getElementById('closeModal');

    // Open modal on thumbnail click
    document.querySelectorAll('#carousel button').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const videoURL = btn.dataset.videourl;
            const payload = `https://www.tiktok.com/oembed?url=${videoURL}`;
            fetch(payload)
                .then(response => response.json())
                .then(data => {
                    const content = document.querySelector('.modal-content');
                    content.innerHTML = `<button class="modal-close" id="closeModal">&times;</button>` + data.html;

                    // Dynamically reload TikTok embed script
                    const script = document.createElement('script');
                    script.src = 'https://www.tiktok.com/embed.js';
                    script.async = true;
                    content.appendChild(script);
                })
                .catch(err => {
                    document.querySelector('.modal-content').innerHTML = '<p>Failed to load video.</p>';
                });

            modal.style.display = 'flex';
        });
    });

    // Close modal on click or background
    modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.id === 'closeModal') {
            closeModal();
        }
    });

    function closeModal() {
        modal.style.display = 'none';
        document.querySelector('.modal-content').innerHTML = ''; // Clear content
    }
})();
